/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-25T09:40:19.464
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousetypepic-'

export default 
{
path: '/rentmanage/renthousetypepic',
name: 'rentmanage-renthousetypepic',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousetypepic-index',

meta:{
...meta,
title: '户型图片'
},

component: () => import('@/pages/rentmanage/renthousetypepic/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousetypepic-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '户型图片编辑'
},

component: () => import('@/pages/rentmanage/renthousetypepic/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousetypepicdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '户型图片新增'
},

component: () => import('@/pages/rentmanage/renthousetypepic/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousetypepicView',
auth: [
'hidden'
],

meta:{
...meta,
title: '户型图片详情查看'
},

component: () => import('@/pages/rentmanage/renthousetypepic/detail-view') ,
},
]
};
